// @ts-nocheck

export default function (store) {
  var funcs = [];
  store.emitChange = function () {
    for (var i = 0; i < funcs.length; i++) {
      funcs[i].apply(null, arguments);
    }
  };
  store.addChangeListener = function (callback) {
    funcs.push(callback);
  };
  store.removeChangeListener = function (callback) {
    funcs.splice(funcs.indexOf(callback), 1);
  };
  return store;
}
